import { AxiosResponseHeaders } from 'axios';
import { FavouriteTransactionResponseDTO } from '../../entities/FavouriteTransaction';
import { FavouriteTransaction } from '../../entities/FavouriteTransaction';

const favouriteTransactionDTOToFavouriteTransactionListAdapter = (
  data: FavouriteTransactionResponseDTO,
  headers?: AxiosResponseHeaders,
): (FavouriteTransaction | undefined)[] => {
  if (!data.body) {
    throw new Error();
  }

  const transactionsList = data.body.favoriteTransactions || [];
  return transactionsList.map(favouriteTransaction => {
    try {
      const requestData = JSON.parse(favouriteTransaction.requestData!);
      return new FavouriteTransaction(
        favouriteTransaction.id,
        favouriteTransaction.appTransactionId,
        favouriteTransaction.appTransactionUniqueId,
        favouriteTransaction.description,
        favouriteTransaction.appTransactionDescription,
        favouriteTransaction.status,
        favouriteTransaction.enabled,
        favouriteTransaction.scheduledDate,
        favouriteTransaction.createdDate,
        favouriteTransaction.lastUpdatedDate,
        requestData.alias,
        requestData.fromAccount,
        requestData.toAccount,
        requestData.details,
        requestData.amount,
        requestData.currency,
      );
    } catch (e) {
      // TODO: place actual error handling by throwing error here after the requestData object has been agreed
      console.log(e);
      return undefined;
    }
  });
};

export { favouriteTransactionDTOToFavouriteTransactionListAdapter };
